var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.isClubSelected
      ? _c(
          "div",
          [
            _c("SelectClubForSignup", {
              attrs: {
                favoritePlayerList: _vm.computedFavoritePlayerList,
                selectedClubCodes: _vm.selectedClubCodes,
                userinfo: _vm.userinfo,
                step: _vm.step,
                isXhr: _vm.isXhr,
              },
              on: {
                next: _vm.next,
                back: _vm.back,
                "club-selected": _vm.handleClubSelection,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isClubSelected
      ? _c(
          "div",
          [
            _c("SelectFavoritePlayerForSignup", {
              attrs: {
                userinfo: _vm.userinfo,
                selectedClubCode: _vm.selectedClubCode,
                favoritePlayerList: _vm.computedFavoritePlayerList,
                selectedClubCodes: _vm.selectedClubCodes,
              },
              on: { "change-view": _vm.handleViewChange },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }